import { render, staticRenderFns } from "./Envios.vue?vue&type=template&id=9cfbc124&"
import script from "./Envios.vue?vue&type=script&lang=js&"
export * from "./Envios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports